import script from "./ParentPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ParentPasswordModal.vue?vue&type=style&index=0&id=91e13f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91e13f78"]])

export default __exports__